export function storySnippet(matchId: string, lang = 'sr', theme = 'dark'): string {
  return `<div data-dp-widget="clip-story" data-dp-api-key="YOUR_WIDGET_KEY" data-dp-match-id="${matchId}" data-dp-lang="${lang}" data-dp-theme="${theme}"></div>`;
}

export function isRealWebhookEvent(d: {
  event_type?: string;
  payload?: unknown;
}): boolean {
  const t = (d.event_type || '').toLowerCase();
  if (t === 'ping' || t === 'webhook.ping' || t === 'webhook.test') return false;
  if (!d.payload || typeof d.payload !== 'object') return true;
  const rec = d.payload as Record<string, unknown>;
  if (rec.fallback === 'ping') return false;
  if (rec.replay === true) return false;
  const inner = rec.payload;
  if (inner && typeof inner === 'object' && (inner as { replay?: boolean }).replay === true) {
    return false;
  }
  return true;
}
